export const CAR_TRANSACTIONS_SUMMARY_PATH = '/cars/transactions/summary';
export const CAR_TRANSACTIONS_SUMMARY_PERMISSION = 'car.transaction.exec_view';

export const getCarTransactionsSummaryNavItem = () => ({
    label: 'Summary',
    to: CAR_TRANSACTIONS_SUMMARY_PATH,
    permissionKey: CAR_TRANSACTIONS_SUMMARY_PERMISSION,
});
